module.exports = __webpack_public_path__ + "img/lab-lock.81ba53e9.svg";